import imageCompression from "browser-image-compression";

import apiClient from "./ApiService";

const uploadFile = (file, url) =>
  fetch(url, {
    method: "PUT",
    body: file,
  });

const getSignedUrl = (key) =>
  apiClient.get(`/file?key=${encodeURIComponent(key)}`);

const deleteFile = (key) =>
  apiClient.delete(`/file?key=${encodeURIComponent(key)}`);

const downloadFile = async (key) => {
  const signedUrl = await getSignedUrl(key);
  setTimeout(() => {
    window.open(signedUrl.data.url, "_blank");
  }, 10);
};

const compressImage = async (file) => {
  const options = {
    maxSizeMB: 1,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
  };
  try {
    const compressed = await imageCompression(file, options);
    return new File([compressed], file.name, { type: compressed.type });
  } catch (error) {
    return file;
  }
};

const uploadCompanyLogo = (companyId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return apiClient.post(`/company/${companyId}/logo`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

const uploadEmployeeIdImage = (companyId, employeeId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return apiClient.post(`/company/${companyId}/employees/${employeeId}/id-image`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

const uploadEmployeeDocuments = (companyId, employeeId, path, files) => {
  const formData = new FormData();
  files.forEach((file) => formData.append('files', file));
  formData.append('path', path);
  return apiClient.post(`/company/${companyId}/employees/${employeeId}/documents/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

const uploadCompanyDocuments = (companyId, path, files) => {
  const formData = new FormData();
  files.forEach((file) => formData.append('files', file));
  formData.append('path', path);
  return apiClient.post(`/company/${companyId}/documents/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

const FileService = {
  uploadFile,
  getSignedUrl,
  deleteFile,
  downloadFile,
  compressImage,
  uploadCompanyLogo,
  uploadEmployeeIdImage,
  uploadEmployeeDocuments,
  uploadCompanyDocuments,
};

export default FileService;
